// conditionally render states based on country dinamically
export const states = (country) => {
    switch (country) {
      case "United States":
        return ["Arizona"];
      default:
        return [""];
    }
  
  }